<!-- Tutor shell: menu column left, content card right; Wissensbasis and
     „Quellen & Suche" as tabs inside the card (like „Verhalten & Fähigkeiten"). -->
<app-tutor-menu>
  <nb-card class="knowledge-card">
    <nb-card-body>
      <nb-tabset *ngIf="ready" routeParam="tab" (changeTab)="onTabChange($event)">
        <nb-tab
          *ngFor="let tab of tabs; trackBy: trackTab"
          [tabId]="tab.key"
          [route]="tab.key"
          [tabTitle]="tab.titleKey | translate"
          [tabIcon]="tab.icon"
          [active]="tab.key === active"
          [lazyLoad]="true"
        >
          <ng-template nbTabTitle>
            <span class="tab-text" [alAnchor]="'tab.' + tab.key" [nbTooltip]="tab.hintKey | translate">{{ tab.titleKey | translate }}</span>
          </ng-template>
          <!-- Nur der offene Reiter baut seinen Inhalt (nb-tab hält
               projizierten Inhalt trotz lazyLoad am Leben). -->
          <ng-container *ngIf="tab.key === active" [ngSwitch]="tab.key">
            <app-tutor-knowledge-base *ngSwitchCase="'base'"></app-tutor-knowledge-base>
            <app-ai-settings *ngSwitchCase="'usage'"></app-ai-settings>
          </ng-container>
        </nb-tab>
      </nb-tabset>
      <nb-spinner *ngIf="!ready" status="basic"></nb-spinner>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
